module.exports = __webpack_public_path__ + "img/oneOrange.e8ae7dbd.jpg";